<ng-container *ngIf="!!params">
    <tt-button-goto ttText="product_print" ttGoto="selectreport" [ttGotoParms]="{ webpage_name: 'product', argtype: 'prod_keyno', argvalue: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_forecast === '1'"
        ttText="product_stockforecast"
        ttGoto="stockforecast"
        [ttGotoParms]="{ prod_id: params.prod_keyno, prodsize_keyno: '0', prodchoice_keyno: '0', stockplace_id: '-' }"
    ></tt-button-goto>
    <tt-button-goto ttText="categorydata" ttGoto="categorydatas" [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto *ngIf="params.planpolicy_no === '2'" ttText="product_show_stock" (ttClick)="gotoSearchStock($event)" [ttLoading]="gotoSearchStockLoading"></tt-button-goto>
    <tt-button-goto ttText="pictures" [ttBadge]="params.nbr_of_pictures" ttGoto="pictures" [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto ttText="documents" [ttBadge]="params.nbr_of_documents" ttGoto="documents" [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto ttText="forms" [ttBadge]="params.nbr_of_checklists" ttGoto="checklistdatas" [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto *ngIf="params.prodsize_keyno > '0'" ttText="product_prodsizeedit" ttGoto="prodsizeedit" [ttGotoParms]="{ prodsize_keyno: params.prodsize_keyno }"></tt-button-goto>
    <tt-button-goto ttText="product_price_edit" ttGoto="productprices" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto ttText="product_pricelistfactors" ttGoto="pricelistfactors" [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto ttText="product_components" [ttBadge]="params.nbr_of_components" ttGoto="components" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_componentalternatives === '1'"
        ttText="componentalternatives"
        [ttBadge]="params.nbr_of_componentalternatives"
        ttGoto="componentalternatives"
        [ttGotoParms]="{ prod_id: params.prod_keyno, comp_keyno: '0' }"
    ></tt-button-goto>
    <tt-button-goto ttText="product_productbom" ttGoto="productbom" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto ttText="product_pics" ttGoto="productpics" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_picturebanks === '1'"
        ttText="product_picturebanks"
        [ttBadge]="params.nbr_of_picturebank"
        ttGoto="picturebanks"
        [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_btn_choices === '1'" ttText="product_choices" [ttBadge]="params.nbr_of_choices" ttGoto="choices" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto ttText="product_prodsizes" [ttBadge]="params.nbr_of_prodsize" ttGoto="prodsizes" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto
        ttText="product_custact"
        [ttBadge]="params.nbr_of_custacts"
        ttGoto="custactsearch"
        [ttGotoParms]="{ filterfield: 'prod_id', filtervalue: params.prod_keyno, custacttype: 'A' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_btn_spareparts === '1'"
        ttText="product_spareparts"
        [ttBadge]="params.nbr_of_spareparts"
        ttGoto="productlinks"
        [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno, productlinktype_keyno: '1' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_btn_substitutes === '1'"
        ttText="product_substitutes"
        [ttBadge]="params.nbr_of_substitutes"
        ttGoto="productlinks"
        [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno, productlinktype_keyno: '2' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_btn_also_buys === '1'"
        ttText="product_also_buys"
        [ttBadge]="params.nbr_of_also_buys"
        ttGoto="productlinks"
        [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno, productlinktype_keyno: '3' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_btn_fits === '1'"
        ttText="product_fits"
        [ttBadge]="params.nbr_of_fits"
        ttGoto="productlinks"
        [ttGotoParms]="{ argtype: 'prod_id', argvalue: params.prod_keyno, productlinktype_keyno: '4' }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="params.show_btn_productcalc === '1'"
        ttText="product_productcalc"
        ttGoto="productcalc"
        [ttGotoParms]="{ prod_id: params.prod_keyno, argtype: 'prod_id', argvalue: params.prod_keyno }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_btn_account_product === '1'" ttText="account_product" ttGoto="accountproduct" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <tt-button-goto *ngIf="params.show_deviantvat_button === '1'" ttText="deviantvat" ttGoto="deviantvat" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-button-goto>
    <!-- <tt-button-save (ttClick)="save()" [ttLoading]="saving" [ttDisabled]="deleting"></tt-button-save> -->
    <tt-product-edit-save [params]="params" [(saving)]="saving" [disabled]="deleting"></tt-product-edit-save>
    <tt-button ttText="product_delete" ttType="danger" ttIcon="fad fa-trash" (ttClick)="deleteProduct()" [ttLoading]="deleting" [ttDisabled]="saving"></tt-button>
    <tt-button-settings *ngIf="params.show_setting === '1'" ttWebpageName="product"></tt-button-settings>
</ng-container>
